import { API } from 'src/api';

export const emojiPopoverService = () => {
  async function getRecentIcons() {
    try {
      const response = await API.get(`/file/emoji`);
      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  async function updateRecentIcon(imgUrl: string) {
    try {
      const response = await API.post(`/file/emoji`, { src: imgUrl });
      if (response.data.success) {
        return true;
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  }

  return {
    getRecentIcons,
    updateRecentIcon,
  };
};
